import { colors } from "@elit-hair/elit-tools";
import BottomSheet from "react-draggable-bottom-sheet";

import useWindowDimensions from "@/hooks/useWindowDimensions";

export const ElitSheet = ({
    children,
    open,
    handleClose,
}: {
    children: React.ReactNode;
    open: boolean;
    handleClose: () => void;
}) => {
    const { size } = useWindowDimensions();

    if (size.md) {
        return (
            <div
                className={`fixed left-0 bottom-0 top-0 right-0 z-50 flex justify-end transition-all ${open ? "backdrop-blur" : "pointer-events-none"}`}
                onClick={() => {
                    handleClose();
                }}
            >
                {open && (
                    <div
                        className="bg-white h-full shadow-elitGrey shadow-lg min-w-80 p-4 w-fit"
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        {children}
                    </div>
                )}
            </div>
        );
    }

    return (
        <BottomSheet
            isOpen={open}
            close={handleClose}
            styles={{
                bottomSheet: {
                    zIndex: 999, // Keep it on top but behind MUI DateTime selector
                    backdropFilter: "blur(10px)",
                    transition: "all 0.2s",
                },
                backdrop: {
                    backgroundColor: colors.elitDarkBlue,
                    opacity: 0.3,
                },
                window: {
                    wrap: {
                        borderRadius: "50px 50px 0 0",
                        overflow: "hidden",
                    },
                },
                draggable: {
                    width: "100%",
                },
                dragIndicator: {
                    indicator: {
                        width: "40%",
                        height: "3px",
                        borderRadius: "50px",
                        background: colors.elitLightGrey,
                    },
                },
            }}
        >
            {open && children}
        </BottomSheet>
    );
};
